interface LoaderProps {
  size?: string;
  color?: string; 
}

const Loader: React.FC<LoaderProps> = ({ size = "24px", color = "#fff" }) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderTop: `4px solid transparent`,
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
      className={`border-[4px] border-${color}`}
    />
  );
};

export default Loader;
